export { renderInput_unstable as renderInput } from '@fluentui/react-input';
